// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__Uzm9F","search":"Settings_search__2c1oj","filter":"Settings_filter__do9Qr"};